<template>
  <div class="home">
    <commonTop />
    <div class="main">
      <router-view />
    </div>
    <commonFooter />
  </div>
</template>

<script setup>
import { isPC } from '@/utils/common.js'
import { onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import commonFooter from '@/components/commonFooter.vue'
import commonTop from '@/components/commonTop.vue'
import wxJDK from 'weixin-js-sdk'
import wx from '@/utils/wx.js'
const store = useStore()
const openid = computed(() => store.state.openid)
const isWeX = computed(() => store.state.isWeX)
const route = useRoute()
const gconfig = computed(() => store.state.gconfig)
// 设置页面标题
document.title =
  gconfig.value.ExhibitionName ||
  '第十六届中国（广饶）国际橡胶轮胎暨汽车配件展览会'
onMounted(() => {
  const isPCRes = isPC()
  store.commit('setIsPC', isPCRes)
  if (/micromessenger/i.test(navigator.userAgent)) {
    store.commit('setIsWeX', true)
    // 获取微信签名 微信配置 分享等
    // wx.getWXSign()
    wxJDK.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        store.commit('setIsMini', true)
      } else {
        store.commit('setIsMini', false)
      }
    })
  } else {
    store.commit('setIsWeX', false)
  }
})
</script>
<style lang="less" scoped>
.home {
  min-height: 100%;
  background: rgb(245, 245, 245);
  .main {
  }
}
@media screen and (min-width: 768px) {
  .home {
    .main {
      width: 80%;
      margin: 0 auto;
    }
  }
}
</style>
